import { Component } from '@angular/core';

@Component({
  moduleId: module.id,
  templateUrl: 'for-signing.component.html',
  providers: []
})

export class ForSigningComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/for-signing.component.ts